import { render } from "./ApprovalsListCardFields.vue?vue&type=template&id=ceff44f2"
import script from "./ApprovalsListCardFields.vue?vue&type=script&lang=js"
export * from "./ApprovalsListCardFields.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__